// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__E6WG8","col":"styles_col__1T0Nq"};